"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = void 0;
exports.instanceOfEntityType = instanceOfEntityType;
exports.EntityTypeFromJSON = EntityTypeFromJSON;
exports.EntityTypeFromJSONTyped = EntityTypeFromJSONTyped;
exports.EntityTypeToJSON = EntityTypeToJSON;
exports.EntityTypeToJSONTyped = EntityTypeToJSONTyped;
/**
 *
 * @export
 */
exports.EntityType = {
    DELETED: 'DELETED',
    USER: 'USER',
    COMMUNITY: 'COMMUNITY',
    COMMUNITY_MEMBER: 'COMMUNITY_MEMBER',
    COMPETITION: 'COMPETITION',
    COMPETITION_ENTRY: 'COMPETITION_ENTRY',
    COMPETITION_PROFILE: 'COMPETITION_PROFILE',
    ENTRY_MEMBER_REQUEST: 'ENTRY_MEMBER_REQUEST',
    ORDER: 'ORDER',
    PRODUCT: 'PRODUCT',
    COMPETITION_SECTION: 'COMPETITION_SECTION',
    COMPETITION_BRACKET: 'COMPETITION_BRACKET',
    BRACKET_MATCH: 'BRACKET_MATCH',
    BRACKET_MATCH_META: 'BRACKET_MATCH_META',
    INBOX_MESSAGE: 'INBOX_MESSAGE',
    COMPETITION_META: 'COMPETITION_META',
    COMPETITION_EVENT: 'COMPETITION_EVENT',
    DONATION: 'DONATION',
    GAME: 'GAME',
    ORGANIZATION: 'ORGANIZATION',
    ACTIVITY: 'ACTIVITY',
    RALLY: 'RALLY',
    PARTY_FINDER_EVENT: 'PARTY_FINDER_EVENT',
    CURATED_FORM: 'CURATED_FORM',
    FORM_RESPONSE: 'FORM_RESPONSE',
    COMPETITION_FORM: 'COMPETITION_FORM',
    USER_META: 'USER_META',
    COMMUNITY_TICKET: 'COMMUNITY_TICKET',
    COMMUNITY_META: 'COMMUNITY_META',
    USER_INBOX_MARKER: 'USER_INBOX_MARKER',
    CONTACT_ACCOUNT: 'CONTACT_ACCOUNT',
    COMPETITION_TICKET: 'COMPETITION_TICKET',
    ACHIEVEMENT: 'ACHIEVEMENT'
};
function instanceOfEntityType(value) {
    for (var key in exports.EntityType) {
        if (Object.prototype.hasOwnProperty.call(exports.EntityType, key)) {
            if (exports.EntityType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function EntityTypeFromJSON(json) {
    return EntityTypeFromJSONTyped(json, false);
}
function EntityTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function EntityTypeToJSON(value) {
    return value;
}
function EntityTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
